import { Link } from '@tanstack/react-router'
import { type FC, type ReactNode } from 'react'

import { type MasterDetailLinkTarget } from '../../-models/resolve-master-detail-link'

type Props = {
  /** null のときはリンクにせず、children をそのまま描画する */
  link: MasterDetailLinkTarget | null
  children: ReactNode
}

// 一覧の検索条件と選択状態を保ったままマスタを確認できるよう、別タブで開く
const NEW_TAB_PROPS = {
  target: '_blank',
  rel: 'noopener noreferrer',
  className: 'text-blue-500'
} as const

export const MasterDetailLink: FC<Props> = ({ link, children }) => {
  if (!link) return <>{children}</>

  switch (link.kind) {
    case 'customer':
      return (
        <Link
          to="/$tenantKey/settings/customers/$customerId"
          params={link.params}
          {...NEW_TAB_PROPS}
        >
          {children}
        </Link>
      )
    case 'partner':
      return (
        <Link
          to="/$tenantKey/settings/partners/$partnerId"
          params={link.params}
          {...NEW_TAB_PROPS}
        >
          {children}
        </Link>
      )
    case 'subPartner':
      return (
        <Link
          to="/$tenantKey/settings/sub-partners/$subPartnerId"
          params={link.params}
          {...NEW_TAB_PROPS}
        >
          {children}
        </Link>
      )
  }
}
